import React, { useContext, useEffect, useRef, useState } from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { powerbi } from "powerbi-client";
import { instance } from '../../store/utils';
import { useDispatch, useSelector } from "react-redux";
import includes from "lodash/includes";
import { isBeneficiary, isKtP, isMinistry, isProvider } from "utils";
import { checkUser, getTaxisData, getUser } from "store/user/actions";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";

const Reports = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reportRef = useRef(null);
  const user = useSelector(state => state.user);
  const groups = useSelector(state => state.user?.groups);
  // const userType = groups && isKtP(groups) ? "ktp" : groups && isProvider(groups) ? "provider" : isMinistry(groups) ? "ministry" : "store";
  const userType = "ministry";   //logika tha allaksei kai tha pairnei mono ktp h tipota (brb w8 for cr)
  const [url, setUrl] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState("");
  const commonList = ["Overview", "Applications"];
  const [usersList, setUsersList] = useState([]);
  const canViewPage = !isBeneficiary(groups);

  const [reportConfig, setReportConfig] = useState({
    type: 'report',
    embedUrl: undefined,
    accessToken: undefined,
    id: undefined,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false
        }
      },
      background: models.BackgroundType.Transparent,
      navContentPaneEnabled: false,
    }
  });

  const getPowerBiLink = async () => {
    //UNCOMMENT IF REPORTS ID NEEDS USERS TYPE (logika den xreiazetai pleon alla ask miltos gia perissoteres plhrofories)

    return await instance.get(`/app/rest/reports/${userType}`).then(response => {
    // return await instance.get(`/app/rest/reports`).then(response => {
      return response;
    });
  };

  const navigateToPage = async (pageName) => {
    setActivePage(pageName); 
    const report = reportRef.current?._embed;
    if (report) {
      const pages = await report.getPages();
      const page = pages.find(p => p.displayName === pageName);
      if (page) {
        await page.setActive();
      }
    }
  };

  useEffect(() => {
    if(groups){
      getPowerBiLink().then((data) => {
        const embedUrlWithLocale = `${data.data.embedReports.embedUrl}&language=en&formatLocale=en-US`;
        setToken(data.data.embedToken.token);
        setUrl(embedUrlWithLocale);
      });
    }
  }, [groups]);

  useEffect(() => {
    dispatch(checkUser(navigate));
    dispatch(getUser());
    dispatch(getTaxisData());
  }, [dispatch, navigate]);

  useEffect(() => {
    if (!canViewPage) navigate("/appTrack", { replace: true });
    //UNCOMMENT AND CUSTOMISE FOR DIFFERENT USER LIST'S

    // if (isKtP(groups)) {
    //   setUsersList(ktpList);
    // } else if (isProvider(groups)) {
    //   setUsersList(providerList);
    // } else if (isMinistry(groups)) {
    //   setUsersList(ministryList);
    // }else {
      setUsersList(commonList);
    // }
  }, [user]);

  useEffect(() => {
    if (token !== "" && url !== "") {
      setReportConfig({
        ...reportConfig,
        embedUrl: url,
        accessToken: token,
        id: url.toString().substring(
          url.toString().indexOf('=') + 1,
          url.toString().indexOf('&')
        ),
        filters: []
      });
      setLoading(false);
    }
  }, [token, url]);

  const applyConditionalFilters = (report) => {
    report.getActivePage().then((page) => {
      //UNCOMMENT THIS AND CUSTOMISE IT AS NEEDED FOR FILTERS
      
      // if (page.displayName !== "Search Vouchers") {
      //   if (userType === "provider") {
      //     const filters = [
      //       {
      //         $schema: "http://powerbi.com/product/schema#basic",
      //         target: {
      //           table: "provider_offer",
      //           column: "provider",
      //         },
      //         operator: "In",
      //         values: [user?.info?.provider],
      //       },
      //     ];
      //     report.setFilters(filters);
      //   } else {
      //     report.setFilters([]);
      //   }
      // } else {
        report.setFilters([]);
      // }
    });
  };

  useEffect(() => {
    const report = reportRef.current?._embed;

    if (report && reportConfig.embedUrl && reportConfig.accessToken && usersList.length > 0) {
      report.on('loaded', async () => {
        await navigateToPage(usersList[0]);
        applyConditionalFilters(report);
      });
      report.on("pageChanged", () => {
        applyConditionalFilters(report);
      });
    }
  }, [reportConfig, user]);

  return (
    loading ?
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Spin size="large" />
      </div>
    :
      <div>
        <div className="custom-nav">
          {usersList.map((item) => (
            <button
              className={usersList.length > 1 && activePage === item ? "active" : ""}
              onClick={() => navigateToPage(item)}
              key={item}
            >
              {item==="Vouchers προς Εκκαθάριση" ? "Vouchers Προς Εκκαθάριση" : item}
            </button>
          ))}
        </div>
        <div className="powerbi-report-style-class">
          <PowerBIEmbed
            ref={reportRef}
            cssClassName={'report-style-class'}
            embedConfig={reportConfig}
          />
        </div>
      </div>
  );
};

export default Reports;
